import { Component, computed, input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { TipsComponent } from '@app/shared/tips/tips.component';
import { LucideChevronDown, LucideChevronUp, LucideX } from '@lucide/angular';
import { AnomalyMarkdownPipe } from '../anomaly-markdown-pipe';
import { bannerMeta } from '../anomaly-presentation';
import { AnomalyDisplayState, BannerAnomaly } from '../anomaly.model';

/**
 * Le bandeau d'une anomalie, sur le modèle de `app-tips` (décision 2026-027/02) : orange tant
 * qu'elle est en cours, réductible mais pas fermable ; vert une fois résolue, fermable.
 */
@Component({
  selector: 'app-anomaly-banner',
  imports: [
    TipsComponent,
    MatButtonModule,
    MatTooltip,
    AnomalyMarkdownPipe,
    LucideChevronUp,
    LucideChevronDown,
    LucideX,
  ],
  templateUrl: './anomaly-banner.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./anomaly-banner.scss'],
})
export class AnomalyBanner {
  readonly anomaly = input.required<BannerAnomaly>();
  readonly state = input<AnomalyDisplayState>('EXPANDED');
  /** Sans actions, le bandeau sert d'aperçu dans le dialogue de saisie. */
  readonly actions = input(true);

  readonly collapse = output<void>();
  readonly expand = output<void>();
  readonly dismiss = output<void>();

  protected readonly resolved = computed(() => this.anomaly().status === 'RESOLVED');
  protected readonly meta = computed(() => bannerMeta(this.anomaly()));
}
